import React from "react";
import LightGallery from "lightgallery/react";

// Import LightGallery plugins
import lgZoom from "lightgallery/plugins/zoom";
import lgThumbnail from "lightgallery/plugins/thumbnail";

import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";

import contactImg1 from "../assest/images/contact-us/cloud.webp";


// Image imports
import aboutImg from "../assest/images/about-us/about-img.png";
import customerImg from "../assest/images/about-us/customer-img-grp.png";

import galleryImg1 from "../assest/images/bike-rider/bike-1.png";
import galleryImg2 from "../assest/images/bike-rider/bike-2.png";
import galleryImg3 from "../assest/images/bike-rider/gallry-1.png";

function Bikerentel() {

  const taxiRates = [
    {
      tour: "Indus Valley to Hemis (1 Day Tour)",
      aPlus: "₹ 6,468",
      a: "₹ 5,880",
      b: "₹ 5,586",
      c: "₹ 4,865",
    },
    {
      tour: "Indus Valley to Sangam Sightseeing",
      aPlus: "₹ 4,995",
      a: "₹ 4,541",
      b: "₹ 4,314",
      c: "₹ 3,910",
    },
    {
      tour: "Nubra Valley (2 Day Tour)",
      aPlus: "₹ 20,658",
      a: "₹ 18,780",
      b: "₹ 17,841",
      c: "₹ 16,176",
    },
    {
      tour: "Nubra + Pangong (3 Day Tour)",
      aPlus: "₹ 40,262",
      a: "₹ 36,602",
      b: "₹ 34,788",
      c: "₹ 31,560",
    },
    {
      tour: "Pangong Lake (1 Day Tour)",
      aPlus: "₹ 17,460",
      a: "₹ 15,873",
      b: "₹ 15,087",
      c: "₹ 13,700",
    },
    {
      tour: "Tso Moriri Lake (3 Day Tour)",
      aPlus: "₹ 30,888",
      a: "₹ 28,080",
      b: "₹ 26,676",
      c: "₹ 24,170",
    },
  ];

  // Define images array for gallery
  const images = [
    { src: galleryImg1, className: "gallery-item" },
    { src: galleryImg2, className: "gallery-item" },
    { src: galleryImg3, className: "gallery-item" },
  ];

  return (

    <div>
      <div className="container-fulid">

        <div className="cloud-img">
          <div className="cloud-move">
            <img src={contactImg1} alt="cloud" />

          </div>
        </div>
        <div className="page-banner page-banner1">
          <div className="main-title">
            <h3 className="breadcrumb-title">Bike Rental</h3>
            <ul className="breadcrumb-menu">
              <li><a className="text-white" href="index.html">Home</a></li>
              <li>-</li>
              <li className="active">Bike Rental</li>
            </ul>
          </div>
        </div>

      </div>

      <section className="home-destination">
        <div className="container">
          <div className="row">

            {/* LEFT CONTENT */}
            <div className="col-lg-6">
              <div
                className="about-content"
                data-aos="fade-up"
                data-aos-duration="1000"
              >

                {/* TITLE */}
                <div className="section-title mb-40">
                  <span>Services</span>
                  <h2>Rentel Bike Services</h2>
                </div>

                <p>
                  Below is the revised price of bikes in Ladakh

                  Considering the types of road and the beating a motorcycle takes on these roads,  The Bike Rental Rates in Ladakh is pretty reasonable. Please refer the table below for the rates and types of motorcycle you want to hire.

                  Renting a bike in Ladakh is simple as producing your driving licence, and another identity card. But keep in mind though; that these roads are tricky and fewer people find themselves in a ditch. You have to be mindful about how to Ride In Ladakh especially when there is sand on the road. Any bike rental company will charge you for the damages on a bike if there is any, and it is important to bring your own gears for the ride, otherwise, we provide them as well.

                  The Cost Of Hiring A Bike is so little when you realise the freedom that a four-wheeler is limited to. We at Mototour Ladakh highly recommend people who are travelling solo to rent a motorcycle and don't let the itinerary take its toll on your freedom.
                </p>

                {/* TABS */}




                {/* BOTTOM */}
                <div className="about-content-bottom mt-5">

                  <a href="/about" className="round-btn">
                    More info
                  </a>

                  <div className="counter-area d-flex align-items-center">

                    <div className="customer-img-grp">
                      <img src={customerImg} alt="customers" />
                    </div>

                    <div className="content ms-2">
                      <div className="number d-flex">
                        <h6 className="counter">500</h6>
                        <span>+</span>
                      </div>
                      <p>Customer</p>
                    </div>

                  </div>

                </div>

              </div>
            </div>

            {/* RIGHT IMAGE */}
            <div className="col-lg-6 d-flex justify-content-end">
              <div className="about-img">
                <img src={aboutImg} alt="about" />
                {/* <img src={vectorImg} className="vector" alt="vector" /> */}
              </div>
            </div>

          </div>
        </div>
      </section>


      {/*gallary-section-start*/}

      <section className="home-gallery home-destination bg-light">
        <div className="container">
          <div className="text-center mb-5">
            <div className="about-content">
              <div className="section-title mb-40">
                <span>Gallary</span>
                <h2>PHOTO'S FROM BIKERS</h2>
              </div>
            </div>
          </div>
          <LightGallery
            plugins={[lgZoom, lgThumbnail]}
            speed={500}
            elementClassNames="gallery-grid gallary-grid-1"
          >
            {images.map((img, i) => (
              <a href={img.src} className={img.className} key={i}>
                <img src={img.src} alt="travel" />
              </a>
            ))}
          </LightGallery>

        </div>
      </section>
      {/*gallary-section-end*/}


      <section className="taxi-section py-5">
        <div className="container">

          <div className="section-title">
            <span>Leh Ladakh Tours</span>
            <h2>Taxi Rates 2026</h2>
            <p>Select your vehicle category & explore Ladakh comfortably</p>
          </div>

          <div className="table-wrapper table-responsive">
            <table className="taxi-table">
              <thead>
                <tr>
                  <th>Tour Package</th>
                  <th>
                    Car A+ <br />
                    <small>Crysta / Scorpio-N / XUV700</small>
                  </th>
                  <th>
                    Car A <br />
                    <small>Innova / Aria / XUV</small>
                  </th>
                  <th>
                    Car B <br />
                    <small>Xylo / Scorpio / Ertiga</small>
                  </th>
                  <th>
                    Car C <br />
                    <small>Sumo / Eeco / Qualis</small>
                  </th>
                </tr>
              </thead>

              <tbody>
                {taxiRates.map((item, index) => (
                  <tr key={index}>
                    <td className="tour-name">{item.tour}</td>
                    <td>{item.aPlus}</td>
                    <td>{item.a}</td>
                    <td>{item.b}</td>
                    <td>{item.c}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

        </div>
      </section>




    </div>
  )
}

export default Bikerentel;
